import React from'react';
import { Container, Row, Col, Image } from 'react-bootstrap';

import CircleImage from 'CoP/assets/img/circle-decor.png'
import CTAIllustration from 'CoP/assets/img/cta-ilus.png'

const CardCTA = () => (
    <div
        style={{
            background: 'linear-gradient(to bottom, #fff5f0, #ffd6c2)',
            borderRadius: '20px',
            margin: '1rem',
            position: 'relative',
            overflow: 'hidden',
        }}
        className='m-md-15 m-5 p-md-15 p-5'
    >   
        {/* Dekorasi lingkaran */}
        <img
            src={CircleImage}
            alt="decor"
            style={{
                position: 'absolute',
                top: '-50px',
                right: '-50px',
                width: '300px',
                opacity: 0.2,
                zIndex: 0,
            }}
        />

        <Container fluid>
            <Row className="align-items-start">
                <Col xs={12} md={7} className="text-start mb-5" style={{ zIndex: 1 }}>
                    <p className="fw-bold text-dark mt-0 pt-3 display-md-5 fs-1 mt-md-15 mb-3">
                        Bagikan hasil kegiatan Community of Practice (CoP)
                    </p>
                    <p className="fw-semibold text-gray-800 mb-0 fs-md-5 fs-5 text-start">
                        Sebarkan semangat alumni! Bagikan kisah ini dan bantu blog alumni LPDP tetap bisa diakses gratis oleh semua.
                    </p>
                </Col>

                <Col xs={12} md={5} className="text-center mt-4 mt-md-0" style={{ zIndex: 1 }}>
                    <Image
                        src={CTAIllustration}
                        alt="CTA Illustration"
                        className="w-md-100 w-50"
                        style={{
                            maxHeight: '420px',
                            objectFit: 'contain',
                            marginBottom: '-25px'
                        }}
                    />
                </Col>
            </Row>
        </Container>
    </div>
);

export default CardCTA;